<template>
  <div class="rich-text-editor">
    <ckeditor
      :editor="editor"
      :model-value="modelValue"
      :config="editorConfig"
      @update:model-value="$emit('update:modelValue', $event)"
    />
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue';

/**
 * Editor HTML con v-model y barra de herramientas completa (a diferencia de EditHtml.vue,
 * que solo tiene heading/negrita/cursiva y usa un evento en lugar de v-model).
 */
export default {
  name: 'RichTextEditor',
  components: { ckeditor: CKEditor.component },
  props: {
    modelValue: { type: String, default: '' },
    placeholder: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        placeholder: this.placeholder,
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            '|',
            'blockQuote',
            'insertTable',
            '|',
            'undo',
            'redo',
          ],
        },
      },
    };
  },
};
</script>

<style>
.rich-text-editor .ck-editor__editable_inline {
  min-height: 14rem;
  max-height: 24rem;
}
.dark .rich-text-editor .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
  border-color: #4b5563;
}
.dark .rich-text-editor .ck.ck-editor__editable,
.dark .rich-text-editor .ck.ck-editor__editable.ck-focused {
  background-color: #374151;
  color: #f3f4f6;
}
.dark .rich-text-editor .ck.ck-toolbar,
.dark .rich-text-editor .ck.ck-toolbar .ck-button,
.dark .rich-text-editor .ck.ck-toolbar .ck-dropdown__button {
  background-color: #1f2937;
  color: #e5e7eb;
  border-color: #4b5563;
}
.dark .rich-text-editor .ck.ck-toolbar .ck-button:hover,
.dark .rich-text-editor .ck.ck-toolbar .ck-button.ck-on {
  background-color: #374151;
}
.dark .rich-text-editor .ck.ck-toolbar .ck-toolbar__separator {
  background-color: #4b5563;
}
.dark .rich-text-editor .ck.ck-editor__editable .ck-placeholder::before {
  color: #9ca3af;
}
</style>
